import "./utils/theme";
import "./utils/configs";
import "./react-components/styles/global.scss";
import styles from "./assets/stylesheets/link.scss";
import "aframe";
import React from "react";
import ReactDOM from "react-dom";
import { FormattedMessage } from "react-intl";
import { Drawer, DrawerBody, Field, ProgressBar } from "@fluentui/react-components";
import registerTelemetry from "./telemetry";
import LinkRoot from "./react-components/link-root";
import { ThemeProvider } from "./react-components/styles/theme";
import { WrappedIntlProvider } from "./react-components/wrapped-intl-provider";
import configs from "./utils/configs";
import { RuntimeFluentProvider } from "./utils/fluent-theme";
import {
  canAttemptLocalBridgeRehydration,
  completeOrStartLocalBridgeRehydration
} from "./utils/local-bridge-rehydration";
import { store } from "./utils/store-instance";

registerTelemetry("/link", `${configs.APP_NAME} Device Link`);

function hasBridgeCallbackState() {
  if (typeof window === "undefined") return false;
  const params = new URLSearchParams(window.location.search);
  return params.has("state");
}

function shouldShowLinkBootstrapLoading() {
  if (hasBridgeCallbackState()) return true;

  try {
    return canAttemptLocalBridgeRehydration();
  } catch (_) {
    return false;
  }
}

function LinkBootstrapLoading() {
  return (
    <RuntimeFluentProvider>
      <WrappedIntlProvider>
        <Drawer separator backdropMotion={null} surfaceMotion={null} size="full" open={true}>
          <DrawerBody className={styles.body}>
            <div className={styles.linkPanel}>
              <div className={styles.contentHeader}>
                <div className={styles.headerEyebrow}>
                  <FormattedMessage id="link-page.welcome" defaultMessage="Welcome" />
                </div>
                <h1 className={styles.contentTitle}>
                  <FormattedMessage id="link-page.enter-code" defaultMessage="Enter Verse Code" />
                </h1>
              </div>
              <div className={styles.bootstrapLoading}>
                <Field
                  className={styles.bootstrapProgress}
                  validationMessage={
                    <FormattedMessage id="link-page.preparing-device-link" defaultMessage="Preparing device link..." />
                  }
                  validationState="none"
                >
                  <ProgressBar thickness="large" />
                </Field>
              </div>
            </div>
          </DrawerBody>
        </Drawer>
      </WrappedIntlProvider>
    </RuntimeFluentProvider>
  );
}

function renderLinkRoot() {
  ReactDOM.render(
    <ThemeProvider store={store}>
      <LinkRoot store={store} />
    </ThemeProvider>,
    document.getElementById("link-root")
  );
}

function renderLinkBootstrapLoading() {
  ReactDOM.render(
    <ThemeProvider store={store}>
      <LinkBootstrapLoading />
    </ThemeProvider>,
    document.getElementById("link-root")
  );
}

async function startLinkPage() {
  if (!shouldShowLinkBootstrapLoading()) {
    renderLinkRoot();
    return;
  }

  renderLinkBootstrapLoading();

  const rehydration = await completeOrStartLocalBridgeRehydration().catch(() => ({ status: "skipped" }));
  if (rehydration.status === "redirecting") {
    return;
  }

  renderLinkRoot();
}

void startLinkPage();
